import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, Data } from "@angular/router";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    standalone: false
})
export class HomePageComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private canvasService: CanvasService,
    public commonService: CommonService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }
  public user_name: string = "";

  report_listing!: any;
  favorite_report_listing!: any;
  categories: any;
  userCategories: any;
  showCarousel: boolean = false;
  showFavCarousel: boolean = false;

  public canvasType = "report";
  getRecentCanvasObjects() {
    this.canvasService.getRecentCanvasObjects().subscribe((data: any) => {
      this.report_listing = data.data;
      this.report_listing.forEach((report: any) => {
        let tempApp = this.getCategory(report.category_id);
        report.category = tempApp;
      });

      if (this.report_listing) {
        this.showCarousel = true;
      }
    });
  }
  getFavoriteCanvasObjects() {
    this.canvasService.getFavoriteCanvasObjects().subscribe((data: any) => {
      this.favorite_report_listing = data.data;
      this.favorite_report_listing.forEach((report: any) => {
        let tempApp = this.getCategory(report.category_id);
        report.category = tempApp;
      });

      if (this.favorite_report_listing) {
        this.showFavCarousel = true;
      }
    });
  }

  getCategory(id: number) {
    let selected = [];
    if (this.categories) {
      selected = this.categories.filter(function (module: any) {
        return module.id == id;
      });
    }
    if (selected[0]) return selected[0].name;
    else return "";
  }

  getCategories() {
    this.commonService.getAllCategories().subscribe((data: any) => {
      this.categories = data.data;
    });
  }

  ngOnInit(): void {
    const data: Data = this.route.snapshot.data;

    let userObject = JSON.parse(sessionStorage.getItem("userObject"));
    if (userObject) {
      this.user_name = userObject.name || "User";
    }
    if (this.user_name.includes(",")) {
      let temp = this.user_name.split(" ");
      this.user_name = temp[1] + " " + temp[0].slice(0, -1);
    }
    if (data.canvasType) {
      this.canvasType = data.canvasType;
      this.canvasService.setType(this.canvasType + "s");
    }

    let temp = this.user_name.split(" ");
    this.user_name = temp[0].charAt(0).toUpperCase() + temp[0].slice(1);
    this.getRecentCanvasObjects();
    this.getFavoriteCanvasObjects();
    this.getCategories();
  }
}
